import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import dietary from '../views/dietary.vue'
import campaign from '../views/campaign.vue'
import solution from '../views/solution.vue'
import partner from '../views/partner.vue'
import map from '../views/map.vue'
import service from '../views/service.vue'
import newsDetail from '../views/newsDetail.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/dietary',
    name: 'dietary',
    component: dietary
  },
  {
    path: '/campaign',
    name: 'campaign',
    component: campaign
  },
  {
    path: '/solution',
    name: 'solution',
    component: solution
  },
  {
    path: '/partner',
    name: 'partner',
    component: partner
  },
  {
    path: '/map',
    name: 'map',
    component: map
  },
  {
    path: '/service',
    name: 'service',
    component: service
  },
  {
    path: '/',
    redirect: { name: 'index' }
  },
  {
    path: '/news',
    name: 'newsDetail',
    component: newsDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
